import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { UiTranslateModule } from '@fcom/ui-translate';
import { NotificationComponent } from '@fcom/ui-components/components/notifications/notification/notification.component';
import { CmsModule } from '@fcom/cms';

import { PipesModule } from '../../pipes/pipes.module';
import { ComponentsModule } from '../../components/components.module';
import { BaseLayoutComponent } from './base-layout.component';

@NgModule({
  imports: [
    RouterModule,
    ComponentsModule,
    CommonModule,
    PipesModule,
    UiTranslateModule,
    NotificationComponent,
    CmsModule,
  ],
  declarations: [BaseLayoutComponent],
  exports: [BaseLayoutComponent],
})
export class BaseLayoutModule {}
